import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ScrollToTop } from "components/core/ScrollToTop";
import { H3 } from "components/core/Typography";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import Container from "components/core/Page/Container";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	PopularCities
} from "components/storages/Common";
import BlogPosts from "components/storages/Common/BlogPosts";
import { MAIN_HEADING } from "components/storages/ContentData/BlogPostsData";
import Intro from "components/stateLanding/Intro/Intro";
import { STATE_PAGE_CONTENT } from "components/stateLanding/ContentData";
import { selectStateDetails } from "store/selectors/StatePages";
import "./StateLandingPage.scss";
import { PAGE_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function StateLandingPage() {
	const {
		allCities,
		meta,
		location: { fullState }
	} = useSelector(selectStateDetails);
	usePageViewTracking(PAGE_TYPES.STATE_LANDING);

	const content =
		STATE_PAGE_CONTENT[fullState.toLowerCase().replace(/ /g, "-")];
	const climateControlledStorage = content["climate-controlled"];
	const [featuredCities, setFeaturedCities] = useState([]);

	useEffect(() => {
		allCities.forEach((item) => {
			setFeaturedCities((pre) => [
				...pre,
				{
					name: item.city,
					link: `https://www.storage.com/${item.uri}`
				}
			]);
		});
	}, [allCities]);
	return (
		<Page
			className="storage-page"
			pageType={PAGE_TYPES.STATE_LANDING}
			title={meta.title}
			description={meta.description}
			canonical={meta.canonical}
		>
			<Container>
				<StorageHeader
					heading={`Find and Rent ${fullState} Storage Units!`}
					level="1"
				/>
				<div className="all-sections">
					<Intro intro={content.intro} />
					<H3
						size="xxlarge"
						last
					>
						{climateControlledStorage.title}
					</H3>
					{climateControlledStorage.body && (
						<Description desc={climateControlledStorage.body} />
					) }
					{climateControlledStorage.descLink && (
						<Description descLink={climateControlledStorage.descLink} />
					) }
					<br />
					<H3 size="xxlarge">
						Find and Rent Storage Units in {fullState} Today!
					</H3>
					{featuredCities && (
						<PopularCities cityLinks={featuredCities} />
					)}
					<LastSearchBar />
				</div>
				<BorderLine />
				<Heading
					content={MAIN_HEADING}
					level="3"
				/>
				<BlogPosts />
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default StateLandingPage;
